import React from "react";
import { inject } from "mobx-react";

import FolderComponent from "./FolderComponent";
import LoadingComponent from "~/components/LoadingComponent";
import AlertComponent from "~/components/AlertComponent";
import { URL_APP_APP_BASE_PATH, PREVIEW_TYPE, FILE_CONTAINER, IMAGE_TYPE, OPTION_TYPE, HIGHLIGHT_TYPE } from "~/configs/constants";
import { isEmptyOrNullStr, isEmptyOrNullInt, getVarFromUrl } from "../../helpers/utils";
import { valueCurrencyToInt }  from "../../helpers/monetary"
import "share-api-polyfill";

@inject("ImageStore", "DeviceStore", "FileStore", "ProductStore", "FontStore", "PageStore", "OrganizationStore", "PreviewStore")
class FolderContainer extends React.Component {
  constructor(props) {
    super(props);

    this.state = {
      isLoading: true,
      image: {},
      searchText:"",
      products:[],
    };
  }

  async componentDidMount() {
    await this.getImage();
  }

  getImage = async () => {
    this.setState({
      isLoading: true,
    });

    const { ImageStore, DeviceStore, PageStore, history } = this.props;
    let pageId = getVarFromUrl("pageId");
    let deviceId = getVarFromUrl("deviceId");
    const imageId = getVarFromUrl("folderId");    
    const hasImage = imageId !== undefined && parseInt(imageId) > 0;    
 
    var page = await PageStore.getPage(pageId);  

    await DeviceStore.setDeviceId(deviceId);
    let device = await DeviceStore.getDevice();

    let image = {};
    image.highlightType = HIGHLIGHT_TYPE.none;
    if (!hasImage){
      image.deviceId = deviceId;
      image.pageId = pageId;
      image.type = IMAGE_TYPE.folder;
    }
    else {
      image = await ImageStore.getImage(imageId);
      if (image === undefined || image === null){
        history.push("devices");
        return;
      }
      pageId = image.pageId;
      deviceId = image.deviceId;
    } 
    
    if (image.name === undefined || image.name === null) image.name = "";

    let imagesContainer = await this.getImagesContainer('', '', image, false);    
    let imageContainer = await this.getImageContainer(imagesContainer, image);
    
    let productResult = await this.getProduct(image);
    let product = productResult.product;
    let products = productResult.products;

    this.setState({
      isLoading: false,
      device,
      page,
      image,
      imagesContainer,
      imageContainer,
      products,
      product
    });
  };

  getImagesContainer = async (filter, imageName, image, webSearch) => {
    const { FileStore } = this.props
    let imagesContainer = [];
    let imagesContainerData = null;

    if (isEmptyOrNullStr(imageName)) imagesContainerData = await FileStore.getImages(filter, webSearch);
    else imagesContainerData = await FileStore.getImagesByName(imageName);
    if (imagesContainerData === null) return null;

    let hasFolderImage = (image.folderImage !== undefined && image.folderImage !== null && image.folderImage.id > 0);

    if (hasFolderImage)
      imagesContainer.push(
      {
        id: image.folderImage.id,
        url: image.folderImage.url,
        name: image.folderImage.description,
        label: image.folderImage.description,
        extension: image.folderImage.extension,
        type: OPTION_TYPE.image
      });

     for (let i = 0; i < imagesContainerData.length; i++) {
      imagesContainer.push(
        {
          id: imagesContainerData[i].id,
          url: imagesContainerData[i].url,
          name: imagesContainerData[i].description,
          label: imagesContainerData[i].description,
          extension: imagesContainerData[i].extension,          
          type: OPTION_TYPE.image
        }
      );
    }

    return imagesContainer;
  };

  getImageContainer = async (imagesContainer, image) => {
    let imageContainer = {};
    if (imagesContainer !== undefined && imagesContainer !== null && imagesContainer.length > 0) imageContainer = imagesContainer[0];
    for (var i = 0; i < imagesContainer.length; i++){
      if (imagesContainer[i].url === image.path){
        imageContainer = imagesContainer[i];
        break;
      }
    };
    return imageContainer;
  };

  getProducts = async (filter, image) => {
    if (filter === "Nenhum ") filter = "";
    const { ProductStore } = this.props
    let products = [];
    let productsData = await ProductStore.searchProductsByDevice(filter, image.deviceId);
    for(let i = 0; i < productsData.length; i++) {
      products.push(this.makeProductItem(productsData[i]));
    }
    return products;
  };

  makeProductItem = (product) => {
    return {
      id: product.productId,
      name: product.name + " " + product.code,
      label: product.name + " " + product.code,
      productId: product.productId,
      code: product.code,
      valueStr: product.valueStr,
      originalValueStr: product.originalValueStr,
      clubValueStr: product.clubValueStr,
      originalValue: product.originalValue,
      clubValue: product.clubValue,
      description: product.description,
      originalName: product.name,
      value: product.value,
      available: product.available,
      isFractioned: product.isFractioned,
      isOffer: product.isOffer,
      isClub: product.isClub,
      imagePath: product.imagePath,
      imageName: this.imageNameMake(product.imagePath)
    };
  }

  imageNameMake = (imageUrl) => {
    try {
      var imageUrlSplit = imageUrl.split(`/${FILE_CONTAINER.images}/`);
      if (imageUrlSplit.length > 1) {        
        return imageUrlSplit[1];
      }
      imageUrlSplit = imageUrl.split(`/${FILE_CONTAINER.webImages}/`);
      imageUrlSplit = imageUrlSplit[1].split("/");
      var result = imageUrlSplit[imageUrlSplit.length - 1];
      return result;
    } catch {
      return null;
    }
  };

  getProduct = async (image) => {
    let products = await this.getProducts("", image);
    let result = {};
    if (image.product != null && image.product.productId > 0)
      result.product = this.makeProductItem(image.product);
    else 
      result.product = products[0];
    
    if (!this.isProductList(result.product, products))
      products.push(result.product);
    
    result.products = products;
    return result;
  }

  isProductList = (product, products) => {
    if (product === undefined || product === null || product.productId === undefined) return false;
    for (var i = 0; i < products.length; i++){
      if (products[i].productId === product.productId){
        return true;
      }
    }; 
    return false;
  };

  isImageContainerList = (imageContainer, imagesContainer) => {
    if (imageContainer === undefined || imageContainer === null || imageContainer.id === undefined) return false;
    for (var i = 0; i < imagesContainer.length; i++){
      if (imagesContainer[i].id === imageContainer.id){
        return true;
      }
    }; 
    return false;
  };

  goDevice = () => {
    const { history } = this.props;
    
    history.push(`page?deviceId=${getVarFromUrl("deviceId")}&pageId=${getVarFromUrl("pageId")}&tab=${getVarFromUrl("tab")}`);
  };

  maintainImage = async () => {
    this.setState({
      isLoading: true
    });

    const { image } = this.state;
    const { ImageStore } = this.props;

    if (isEmptyOrNullStr(image.path)) AlertComponent.error("Nenhuma imagem do produto selecionada");
    else if (isEmptyOrNullInt(image.productId)) AlertComponent.error("Nenhum produto selecionado");
    else {      
      image.product.name = image.product.originalName;
      const formData = new FormData();
      formData.append("payload", JSON.stringify(image));
      const result = await ImageStore.maintainImage(formData);

      if (result === "") {
        AlertComponent.success("Cartaz salvo com successo");
        this.goDevice();
      }
      else 
        AlertComponent.success("Falha ao salvar cartaz");
    }

    this.setState({
      isLoading: false
    });
  };

  onInputChangeImageContainer = async (event, value) => {
    const { image } = this.state;
    if (event !== null) {
      if (event.type === "change") {
        try {
          this.setState({
            imageIsLoading: true
          });
          const { imageContainer } = this.state;
          let imagesContainer = await this.getImagesContainer(value, '', image, false);
         
          if (!this.isImageContainerList(imageContainer, imagesContainer))
            imagesContainer.push(imageContainer);

          this.setState({
            imagesContainer: imagesContainer,
            imageIsLoading: false
          });
        }
        catch {}
      }
      else {
        try {    
          const { image, imageContainer, imagesContainer } = this.state;
          
          let imageContainerSelected = imageContainer;
          for (var i = 0; i < imagesContainer.length; i++){
            if (imagesContainer[i].name === value){
              imageContainerSelected = imagesContainer[i];
              break;
            }
          }

          image.path = imageContainerSelected.url;
          image.fileName = imageContainerSelected.name;
          image.extension = imageContainerSelected.extension;
          this.setState({
            imageContainer: imageContainerSelected,
            image: image
          });
        }
        catch {}
      }
    }
  };

  onChange = async (e) => {
    const { image } = this.state;
    const updatedImage = {
      ...image,
      [e.target.name]: e.target.value     
    }

    this.setState({
      image: updatedImage
    });
  };

  onChangeValue = (value) => {
    const { image, product } = this.state;
    image.product.valueStr = value;
    image.product.value = valueCurrencyToInt(value);
    product.valueStr = image.product.valueStr;
    product.value = image.product.value;
    product.name = product.originalName;
    this.setState({
      image,
      product: this.makeProductItem(product)
    });
  };

  onChangeOriginalValue = (value) => {
    const { image, product } = this.state;
    image.product.originalValueStr = value;
    image.product.originalValue = valueCurrencyToInt(value);
    product.originalValueStr = image.product.originalValueStr;
    product.originalValue = image.product.originalValue;
    product.name = product.originalName;
    this.setState({
      image,
      product: this.makeProductItem(product)
    });
  };

  onChangeClubValue = (value) => {
    const { image, product } = this.state;
    image.product.clubValueStr = value;
    image.product.clubValue = valueCurrencyToInt(value);
    product.clubValueStr = image.product.clubValueStr;
    product.clubValue = image.product.clubValue;
    product.name = product.originalName;
    this.setState({
      image,
      product: this.makeProductItem(product)
    });
  }; 

  onChangeName = (name) => {
    const { image, product } = this.state;
    image.product.name = name;
    image.product.originalName = image.product.name;
    product.name = image.product.name;
    product.originalName = image.product.name;
    this.setState({
      image,
      product: this.makeProductItem(product)
    });
  };  

  onChangeCode = (code) => {
    const { image, product } = this.state;
    image.product.code = code;
    product.code = image.product.code;
    product.name = product.originalName;
    this.setState({
      image,
      product: this.makeProductItem(product)
    });
  };  

  onChangeIsFractioned = (value) => {
    let { image, product } = this.state;
    image.product.isFractioned = value;
    product.isFractioned = image.product.isFractioned;
    product.name = product.originalName;
    this.setState({
      image,
      product: this.makeProductItem(product)
    });
  };
  
  onChangeDescription = (description) => {
    const { image, product } = this.state;
    image.product.description = description;
    product.description = image.product.description;
    product.name = product.originalName;
    this.setState({
      image,
      product: this.makeProductItem(product)
    });
  };  

  onInputChangeProduct = async (event, value) => {
    if (event !== null) {
      try { 
          if (event.type === "change") {
            this.setState({
              productIsLoading: true,
            });
            const { image, product } = this.state;
            let products = await this.getProducts(value, image);
      
            if (!this.isProductList(product, products))
              products.push(product);
      
            this.setState({
              products,
              productIsLoading: false
            });
          }
          else {
            const { products, product } = this.state;
            let productSelected = product;
            for (var i = 0; i < products.length; i++){
              if (products[i].name === value){
                productSelected = products[i];
                break;
              }
            }
            await this.onChangeProduct(productSelected);            
          }          
        }
      catch { }
    }
  };

  onChangeProduct = async (product) => {
    try {     
      const { FileStore } = this.props
      const { products } = this.state;
      let searchProduct;

      if (isEmptyOrNullStr(product?.imagePath)) {   
        searchProduct = await this.searchProduct(product);        
      }
      else {
        const isValid = await FileStore.isValid(product?.imagePath);
        if (isValid) {
          searchProduct = await this.searchProduct(product);
        }
        else { 
          product.imagePath = "";
          searchProduct = await this.searchProduct(product);
        }
      }

      if (!this.isProductList(searchProduct.product, products))
        products.push(product);

      if (product.isOffer) searchProduct.updatedImage.highlightType = HIGHLIGHT_TYPE.offer;
      else if (product.isClub) searchProduct.updatedImage.highlightType = HIGHLIGHT_TYPE.club;

      this.setState({
        imagesContainer: searchProduct.updatedImagesContainer,
        imageContainer: searchProduct.updatedImageContainer,
        products: products,
        product: searchProduct.product,        
        image: searchProduct.updatedImage
      });
    }
    catch {}
  };

  onWebSearch = async () => {
    this.setState({
      isLoading: true
    });
    let { image, product, imageContainer } = this.state;
    if (imageContainer === undefined || imageContainer === null) imageContainer = {};
    let imagesContainer = await this.getImagesContainer(product?.name, '', image, true);
    if (imagesContainer.length > 1){
      imageContainer = imagesContainer[1];
      product.imagePath = imagesContainer[1].url;
      image.path = imagesContainer[1].url;
    }
    this.setState({
      isLoading: false,
      product: product,
      image: image,
      imagesContainer: imagesContainer,
      imageContainer: imageContainer
    });
  };

  searchProduct = async (product) => {
    const { imagesContainer, image } = this.state;
    let updatedImageContainer = imagesContainer[0];
    let updatedImagesContainer = imagesContainer;
    let updatedImage = image;            
    updatedImage.product = product
    updatedImage.productId = product.productId;

    if (isEmptyOrNullStr(product.imageName)){
      updatedImagesContainer = await this.getImagesContainer(product?.code, '', updatedImage, false);
      if (updatedImagesContainer !== null && updatedImagesContainer.length === 2) {
        updatedImageContainer = updatedImagesContainer[1];
        product.imagePath = updatedImageContainer.url;
        updatedImage.path = updatedImageContainer.url;
      }
      else {
        updatedImagesContainer = await this.getImagesContainer(product?.name, '', updatedImage, false);
        if (updatedImagesContainer === null) updatedImagesContainer = await this.getImagesContainer('', '', updatedImage, false);
      }      
    }
    else {      
      updatedImagesContainer = await this.getImagesContainer('', product.imageName, updatedImage, false);
      if (updatedImagesContainer !== null && updatedImagesContainer.length === 2) {
        updatedImageContainer = updatedImagesContainer[1];
        product.imagePath = updatedImageContainer.url;
        updatedImage.path = updatedImageContainer.url;
      }
    }
    return {
      updatedImageContainer: updatedImageContainer,
      updatedImagesContainer: updatedImagesContainer,
      updatedImage: updatedImage,
      product: product
    }
  }

  preview = async () => {
    try {
      setTimeout(async() => {
        const iframe = document.getElementById("tagPreview");
        const fallback = document.getElementById("fallback");
        const loader = document.getElementById("loader");
        const { PreviewStore } = this.props;
        const deviceId = getVarFromUrl("deviceId");
        const pageId = getVarFromUrl("pageId");

        fallback.style.display = "none";
        loader.style.display = "flex";
        iframe.style.opacity = 0; 

        let preview = {};
        let image = JSON.parse(JSON.stringify(this.state.image));
        if (image.product !== undefined && image.product !== null) {
          image.product.name = isEmptyOrNullStr(image.product.originalName) ? image.product.name : image.product.originalName;
        }
      
        preview.payload = JSON.stringify(image);
        preview.type = PREVIEW_TYPE.folder;
        preview.deviceId = deviceId;
        preview.pageId = pageId;
        preview = await PreviewStore.add(preview);
        
        const path = URL_APP_APP_BASE_PATH + "?preview=" + preview.previewId.toString();

        iframe.src = path;

        window.addEventListener("message", (event) => {
          if (event.data.msg === "PREVIEW_READY") {
            iframe.style.transition = "opacity 0.5s ease";
            iframe.style.opacity = 1;
            loader.style.display = "none";
            fallback.style.display = "none";
          }
        });
      }, 0);
    } catch {}
  };

  render() {
    const { isLoading, image, imageContainer, imagesContainer, products, product, 
      productIsLoading, imageIsLoading, page } = this.state;
    return (
      <>
        {(isLoading && (
          <>
            <LoadingComponent />
          </>
        )) || (
          <div className="content content-xs" style={{overflow: "hidden"}} >
            <FolderComponent
              onChange={this.onChange}
              onClick={this.maintainImage}
              onCancel={this.goDevice}
              onInputChangeImageContainer={this.onInputChangeImageContainer}              
              image={image}
              page={page}
              imageContainer={imageContainer}
              imagesContainer={imagesContainer}
              products={products}
              product={product}
              onInputChangeProduct={this.onInputChangeProduct}
              productIsLoading={productIsLoading}      
              imageIsLoading={imageIsLoading}
              onChangeOriginalValue={this.onChangeOriginalValue}
              onChangeClubValue={this.onChangeClubValue}
              onWebSearch={this.onWebSearch}
              preview={this.preview}
              onChangeIsFractioned={this.onChangeIsFractioned}
              onChangeValue={this.onChangeValue}
              onChangeName={this.onChangeName}
              onChangeCode={this.onChangeCode}
              onChangeDescription={this.onChangeDescription}
            />            
          </div>
        )}
      </>
    );
  }
}

export default FolderContainer;